

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaAgreement', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaAgreementContingency');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaAgreementContingency');
            });

            (0, _squid.$populate)($scope, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
                $scope.sepa.action('sepaDirectMandate', {
                    resultModel: $scope.sepa,
                    data: {
                        bank: {
                            id: $scope.sepa.bankId
                        }
                    },
                    success: function success() {
                        $scope.onSubmit = function () {
                            $scope.parentCallbacks.sepaAccept();
                        };
                    }
                });
            });
        }]
    };
});

_squid.$populate;

_index.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js
// module chunks = 0